import { TipoDocumento } from '../../models/tipo-documento';
import { TipologicaDTO } from '../../models/tipologica-d-t-o';

export class NewFile {

	constructor(
		public tempId: string,
		public file: File,
		public tipoDocumento: TipoDocumento,
		public soggettoEmittente: string,
		public dataDocumento: Date,
		public numeroDocumento: string,
		public codiceTipoEmittente: string,
		public nota: string) {
	}
}
